<template>
  <div class="workflow-wrapper">
    <workarea key="workarea"></workarea>
  </div>
</template>

<script lang="ts">
  import Vue from 'vue';
  import Workarea from './view-settings-section-workarea.vue';

  export default Vue.extend({
    components: {
      Workarea,
    }
  })
</script>